import client from './client';
import { OrderSheet } from '../types';

export const getOrderSheets = async (): Promise<OrderSheet[]> => {
    const response = await client.get('order-sheets/admin');
    return response.data;
};

export const getActiveOrderSheet = async (storeId?: string): Promise<OrderSheet | null> => {
    const response = await client.get('order-sheets/active', { params: { storeId } });
    return response.data;
};

export const createOrderSheet = async (data: Partial<OrderSheet>): Promise<OrderSheet> => {
    const response = await client.post('order-sheets', data);
    return response.data;
};
export const updateOrderSheet = async (id: string, updates: Partial<OrderSheet>) => {
    const response = await client.patch(`order-sheets/${id}`, updates);
    return response.data;
};

export const settleOrderSheet = async (storeId?: string) => {
    const response = await client.post('/order-sheets/settle', { storeId });
    return response.data;
};

export const registerProductsToOrderSheet = async (id: string, productIds: string[]) => {
    const response = await client.post(`/order-sheets/${id}/products`, { productIds });
    return response.data;
};

export const deleteOrderSheet = async (id: string) => {
    const response = await client.delete(`order-sheets/${id}`);
    return response.data;
};
